module.exports = __webpack_public_path__ + "static/media/Montserrat-Light.2f354053.ttf";